package com.eladfinish.bible.contest.screens.randomVerse.usecases

import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.di.config.DebugInfo
import io.github.aakira.napier.Napier

class GetNamesToHideUseCase(
    private val assetReader: AssetReader,
    private val debugInfo: DebugInfo,
) {

    operator fun invoke(
        chapterFilename: String,
        parasha: String,
        namesToHide: StringBuilder,
    ): List<String> {

        Napier.d("getNamesToHide_ test chapterFilename $chapterFilename")
        // chapterFilename is "_<book number>_<book>-<chapter>.txt"; the book's own names file drops the chapter
        val namesFilePrefix = ChaptersRepository.PEOPLE_NAMES + assetReader.fileSeparator + ChaptersRepository.NAMES_PREFIX
        val bookFileName = namesFilePrefix + chapterFilename.substringBefore(CHAPTER_SEPARATOR) + ChaptersRepository.TXT
        Napier.d("getNamesToHide_ test bookFileName $bookFileName")
        val names = assetReader.readFileShared(bookFileName)
        var moreNames = ""
        try {
            val fileName = namesFilePrefix + chapterFilename
            Napier.d("getNamesToHide_ test fileName $fileName")
            moreNames = assetReader.readFileShared(fileName)
            Napier.d("getNamesToHide_ test moreNames $moreNames")
        } catch (_: Exception) {
            // file doesn't exist for this chapter — that's expected
        }
        if (debugInfo.isDebugMode) {
            namesToHide.append(
                """
                    
                    ברמת הספר:
                    $names

                    ברמת הפרק:
                    $moreNames
                    """.trimIndent()
            )
            namesToHide.append(
                """
                    
                    פרשה:
                    $parasha
                    """.trimIndent()
            )
        }

        return (names + "\n" + moreNames).split("\n")
            .map { it.trim() }
            .filter { it.isNotEmpty() && !it.startsWith(COMMENT_PREFIX) }
    }

    private companion object {
        const val CHAPTER_SEPARATOR = "-"

        // A book with no names to hide still needs its file (it is read unconditionally), so it holds a comment line
        const val COMMENT_PREFIX = "#"
    }

}
